
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import { addMoments, uploadFile } from '@/api/yuangongquan'
import config from '@/config/index'
import { getConfig, addFile } from '@/api/wx.js'
import { operateCreditlist } from '@/api/user'
export default {
directives: {
TransferDom
},
components: { XTextarea, InlineXSwitch, Popup },
data () {
return {
showmenu: false,
baseUrl: config.baseUrl,
text: '',
deptshow: 0,
photoObj: {
imgcount: 9,
imglist: [],
fileUrlArr: []
},
videoObj: []
}
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.wxconfig()
},
methods: {
add () {
if (this.photoObj.imglist.length > 0) {
this.chooseFile(this.photoObj.imglist, this.photoObj.imgcount)
} else {
this.showmenu = true
}
},
uploadVideo () {
this.showmenu = false
},
onChange () {
let file = this.$refs.file
let formData = new FormData()
let fileObj = file.files[0]
if (fileObj.size > 50 * 1024 * 1024) {
alert('视频大于50M，请重新上传')
return
}

formData.append('file', fileObj)
uploadFile(formData).then(res => {
this.videoObj = res.obj
})
},
submit () {




let fileids = ''
let vidoId = ''
if (this.photoObj.imglist.length > 0) {
let arr = this.photoObj.imglist.map(item => item.id)
fileids = arr.join(';')
} else if (this.videoObj.length > 0) {
vidoId = this.videoObj[0].id
fileids = this.videoObj[1].id
}
if (fileids === '' && vidoId === '') {
this.$vux.toast.text('请先上传图片或视频')
return false
}
addMoments({
text: this.text,
userid: this.userid,
fileids: fileids,
vidoId: vidoId,
deptid: '',
url: '',
deptshow: this.deptshow
}).then(res => {
this.$vux.toast.text('提交成功')

operateCreditlist({
accountid: this.accountid,
rulecode: 'publish',
credit: 5,
owner_type: config.owner_type,
terminaltype: 2
})
setTimeout(() => {
this.$router.push({ name: 'yuangongquanMy', params: { id: this.userid } })
}, 1200)
})
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, imgcount) {

this.showmenu = false
var _this = this
wx.chooseImage({
count: imgcount - imglist.length, // 默认5
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.uploadFile(imglist, localIds)
}
}
})
},

uploadFile (imglist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
_this.photoObj.fileUrlArr.push(re.returnValue.filepath)
_this.index++
_this.uploadFile(imglist, localIds)
})
}
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
del (index) {
this.photoObj.imglist.splice(index, 1)
},
del2 () {
this.videoObj = []
this.$refs.file.value = ''
}
}
}
